// extracted by css-extract-rspack-plugin
export default {"root":"fCwrf0","button":"lEAJhw","active":"C8zR51"};